import React, { useState } from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArcaPdfStudioLayout from '../../components/arca/ArcaPdfStudioLayout';
import { appendUploadFiles, isImageFile } from '../../components/arca/uploadItemUtils';
import { getToken } from '../../api/client';
import API_CONFIG from '../../config/api';

function baixarBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default function ArcaPdfJpgParaPdfPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const addFiles = (files) => {
    setError('');
    const n = appendUploadFiles(files, setItems, { multiple: true, filter: isImageFile });
    if (!n) setError('Selecione imagens JPG ou PNG.');
  };

  const handleConvert = async () => {
    setError('');
    if (!items.length) {
      setError('Adicione ao menos uma imagem.');
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      items.forEach((it) => fd.append('files', it.file, it.file.name));
      const token = getToken();
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/arca/pdf/convert/jpg-to-pdf`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: fd,
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Erro na conversão (${res.status}).`);
      }
      const blob = await res.blob();
      const disposition = res.headers.get('Content-Disposition') || '';
      const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
      const filename = match
        ? decodeURIComponent(match[1].replace(/"/g, ''))
        : `imagens-${Date.now()}.pdf`;
      baixarBlob(blob, filename);
    } catch (e) {
      console.error('[ArcaPdfJpgParaPdf]', e);
      setError(e.message || 'Erro ao converter.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ArcaPdfStudioLayout
      title="JPG para PDF"
      info="Arraste e solte para reordenar. Clique no thumbnail para visualizar. A ordem dos cards será a ordem das páginas."
      limits={
        <>
          JPG ou PNG · até <strong>50 MB</strong> cada.
        </>
      }
      error={error}
      onClearError={() => setError('')}
      items={items}
      setItems={setItems}
      loading={loading}
      enableRotate={false}
      dropzone={{
        accept: 'image/jpeg,image/jpg,image/png,.jpg,.jpeg,.png',
        multiple: true,
        maxSizeMb: 50,
        onFilesAdd: addFiles,
        label: 'Arraste imagens ou clique para selecionar',
        hint: 'JPG ou PNG · máx. 50MB cada',
      }}
      actionLabel="Converter e baixar PDF"
      actionLoadingLabel="Convertendo…"
      actionStartIcon={<PictureAsPdfIcon />}
      onAction={handleConvert}
      actionDisabled={!items.length}
    />
  );
}
